import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useIntl, FormattedMessage } from "react-intl";
import { Button } from "@ts-digital/vrc";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MacroCategoriesTitles } from "../../constants/document_categories";
import imgWidgetNoDocumenti from "../../assets/img/imgWidgetNoDocumenti.svg";
import { getCountDocumentsByCategory } from "../../store/actions/statistics";
import { getDocsWidget, getDocumentsWithSearch } from "../../store/actions/documentsWithSearch";
import HeaderAddButton from "../general/pageHeader/headerAddButton";
import { MacroCategoriesSorting } from "../../constants/document_categories";
import { usePermissions } from "../../customHooks";
import WidgetCard from "./card";

const WidgetTotalDocsNew = props => {
  const {
    accountantSelected,
    accountantIdSelected,
    companySelected,
    clientIdSelected    
  } = props;
  const location = useLocation();
  const navigate = useNavigate();
  /** EVITA DI DOVER USARE LA CONNECT PERFORMANCE TOP */
  const statistics = useSelector(state => state.statistics);
  const auth = useSelector(state => state.auth);
  const docsWidget = useSelector(state => state.documentsWithSearch.docsWidgetData);
  const documentsWithSearch = useSelector(state => state.documentsWithSearch);
  const currentPermissions = useSelector(state => state.currentPermissions);
  const dispatch = useDispatch();

  const toReadText = useIntl().formatMessage({
    id: "customerPage.docsWidget.daleggere"
  });
  const documentTitleText = useIntl()
    .formatMessage({ id: "documents.title" })
    .toLowerCase();
  const { isPermissionWebUpload } = usePermissions(currentPermissions);

  /** È come una componentDidUpdate in cui quando varia uno degli elementi nel secondo parametro (quelli tra quadre)
   * allora viene eseguita getCountDocumentsByCategory */

  useEffect(() => {
    /** Se va valutata una condizione meglio valutare la negazione per poi fare return  */
    if (!auth) return;
    dispatch(getDocumentsWithSearch(
      "",
      "",
      false
    ));
    dispatch(getDocsWidget());
  }, [
    auth,
    accountantSelected,
    accountantIdSelected,
    companySelected,
    clientIdSelected
  ]);

  useEffect(() => {
    /** Se va valutata una condizione meglio valutare la negazione per poi fare return  */
    // Se non ci sono documenti (nè letti nè non letti), la chiamata per il conteggio dei non letti non la faccio
    if (!auth) return;

    dispatch(getCountDocumentsByCategory(clientIdSelected,
      accountantIdSelected));
  }, [
    auth,
    companySelected,
    clientIdSelected,
    accountantSelected,
    accountantIdSelected
  ]);

  const renderTitle = title => {
    return MacroCategoriesTitles[title.toLowerCase()] || title;
  };

  const renderLeftToRead = () => {

    return (
      <div
        style={{
          flex: "1 1 auto",
          width: "35%",
          cursor: "pointer"
        }}
        onClick={e => {
          navigate({
            pathname: "/documenti",
            state: { macro: "Tutti" }
          });
        }}
      >
        <div
          style={{
            alignItems: "center"
          }}
        >
          <div
            style={{
              margin: "0px auto",
              background: "rgb(0, 144, 209)",
              fontFamily: "Roboto, sans-serif",
              color: "rgb(255, 255, 255)",
              fontSize: "28px",
              fontWeight: "bold",
              height: "100px",
              lineHeight: "100px",
              minWidth: "100px",
              maxWidth: "100px",
              borderRadius: "50%",
              textAlign: "center"
            }}
          >
            {docsWidget?.docsWidget?.totalCount}
          </div>
          <div
            id="titleToRead"
            style={{
              fontSize: "18px",
              fontFamily: "Cairo, sans-serif",
              fontWeight: 600,
              color: "#35383a",
              marginRight: "20px",
              marginLeft: "20px",
              textAlign: "center"
            }}
          >
            {toReadText}
          </div>
        </div>
      </div>
    );
  };

  const renderRigthInBox = flattenArray => {
    let arrayRowTotal = []; // array degli elementi con totale > 0
    let arrayRowStock = []; // array degli elementi a 0 per avere una riserva
    let arrayDomElements = []; // creo i div per la visualizzazione e li salvo in questo array
    for (let el = 0; el < flattenArray.length; el++) {
      /**
       * voglio dare la priorità alle categorie con totale > 0
       * riempio 2 array uno che ha i totali >0 e l'altro no
       */
      if (flattenArray[el].docCount > 0) {
        arrayRowTotal.push(flattenArray[el]);
      } else {
        arrayRowStock.push(flattenArray[el]);
      }
    }
    // concateno i 2 array popolati in maniera che i totali > 0 abbiano la precedenza
    let arrayRows = arrayRowTotal.concat(arrayRowStock);
    // visualizzo i primi 5 e li ordino secondo MacroCategoriesSorting
    let items = [];
    for (let counter = 0; counter < 7; counter++) {
      if (
        arrayRows.length > 0 &&
        arrayRows.length > counter &&
        arrayRows[counter].docCount > 0
      ) {
        MacroCategoriesSorting.indexOf(arrayRows[counter].bucketName.toLowerCase()) !== -1
          ? (items[
            MacroCategoriesSorting.indexOf(arrayRows[counter].bucketName.toLowerCase())
          ] = arrayRows[counter])
          : items.push(arrayRows[counter]);
      }
    }
    arrayRows = items;
    for (let counter = 0; counter < 7; counter++) {
      if (
        arrayRows.length > 0 &&
        arrayRows.length > counter &&
        arrayRows[counter] &&
        arrayRows[counter].docCount > 0
      ) {
        let value = arrayRows[counter].docCount > 999 ? "+999" : arrayRows[counter].docCount;
        arrayDomElements.push(<div
          style={{ cursor: "pointer" }}
          key={"arrayDom_" + counter}
          className="listTotalDocsCategory"
          onClick={e => {
            navigate({
              pathname: "/documenti",
              state: { macro: arrayRows[counter].bucketName }
            });
          }}
        >
          <div style={{ display: "flex", margin: "2px" }}>
            <div style={{ width: "50px", marginRight: "20px" }}>
              <div className="ovalNumber">
                <div>{value}</div>
              </div>
            </div>
            <div className="rightTitle">
              {renderTitle(arrayRows[counter].bucketName)}
            </div>
          </div>
        </div>);
      }
    }
  
    return (
      <div
        style={{
          flex: "1 1 auto",
          width: "50%",
          fontSize: "12px",
          fontFamily: "Roboto, sans-serif",
          lineHeight: 2
        }}
      >
        {arrayDomElements}
      </div>
    );
  };

  // Per prima cosa controllo se non ci sono documenti in generale (letti e non letti)
  const type =
    location &&
      location.pathname !== "/scheda-cliente"
      ? "box1_3"
      : null;
  return !documentsWithSearch.isGettingDocumentsWithSearch &&
    !documentsWithSearch.results.list ? null : documentsWithSearch.isGettingDocumentsWithSearch ? (
      <WidgetCard
        type={type}
        titleWidget={documentTitleText}
        footer={null}
        isCentered={true}
      >
        <FontAwesomeIcon
          icon={["far", "circle-notch"]}
          style={{ fontSize: "50px", color: "#2184C2" }}
          spin
        />
      </WidgetCard>
    ) : documentsWithSearch.results.list &&
      documentsWithSearch.results.list.length === 0 ? (
        <WidgetCard
          type={type}
          titleWidget={documentTitleText}
          footer={null}
          isCentered={false}
          style={{ display: "flex", flexDirection: "column", height: "100%" }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center"
            }}
          >
            <div
              style={{
                color: "rgb(0, 80, 117)",
                fontFamily: "Cairo, sans-serif",
                fontSize: "16px",
                fontWeight: 600,
                lineHeight: "24px"
              }}
            >
              <FormattedMessage id="customerPage.docsWidget.noDocuments" />
            </div>
            {isPermissionWebUpload ? (
              <>
                <div
                  style={{
                    color: "rgb(21, 41, 53)",
                    fontSize: "12px",
                    letterSpacing: "0.33px",
                    lineHeight: "16px",
                    marginBottom: "16px",
                    flex: "0 0 auto"
                  }}
                >
                  <FormattedMessage id="customerPage.docsWidget.inviteUpload" />
                </div>
                <div>
                  <HeaderAddButton isDocumentsButton={true} />
                </div>
              </>
            ) : null}
          </div>
          <div className="backgroundDocuments" />
        </WidgetCard>
      ) : // Se esiste qualche documento, passo al controllo dei documenti non letti
      !statistics.isGettingCountDocumentsByCategory &&
      !statistics.totalsDocumentsByCategory
        ? null : statistics.isGettingCountDocumentsByCategory ? (
          <WidgetCard
            type={type}
            titleWidget={documentTitleText}
            footer={null}
            isCentered={true}
          >
            <FontAwesomeIcon
              icon={["far", "circle-notch"]}
              style={{ fontSize: "50px", color: "#2184C2" }}
              spin
            />
          </WidgetCard>
        ) : statistics.totalsDocumentsByCategory &&
        statistics.totalsDocumentsByCategory.results.length === 0 ? (
            <WidgetCard
              type={type}
              titleWidget={documentTitleText}
              footer={null}
              isCentered={false}
            >
              <div style={{ textAlign: "center" }}>
                <FontAwesomeIcon
                  icon={["fas", "check-circle"]}
                  style={{ fontSize: "48px", color: "#09822a" }}
                />
              </div>
              <div style={{ textAlign: "center" }}>
                <div
                  style={{
                    color: "rgb(0, 80, 117)",
                    fontFamily: "Cairo, sans-serif",
                    fontSize: "16px",
                    fontWeight: 600,
                    lineHeight: "24px",
                    marginBottom: "20px",
                    marginTop: "20px"
                  }}
                >
                  <FormattedMessage id="customerPage.docsWidget.noDocumentsUnread" />
                </div>

                <Button kind="secondary" onClick={() => navigate("/documenti")}>
                  <FormattedMessage id="customerPage.docsWidget.documentsView" />
                </Button>
              </div>
              <div
                style={{
                  bottom: "0",
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center"
                }}
              >
                <img width="60%" src={imgWidgetNoDocumenti} alt="Widget docs" />
              </div>
            </WidgetCard>
          ) : (
            <WidgetCard
              type={type}
              titleWidget={documentTitleText}
              footer={null}
              isCentered={false}
              style={{ display: "flex", flexDirection: "column", height: "100%" }}
            >
              <div
                style={{
                  flexDirection: "row",
                  display: "flex",
                  color: "#152935"
                }}
              >
                {renderLeftToRead()}
                {renderRigthInBox(docsWidget?.docsWidget?.aggregationValue?.macrocategory)}
              </div>

              <div className="backgroundDocuments" />
            </WidgetCard>
          );
};

export default WidgetTotalDocsNew;
